module.exports = __webpack_public_path__ + "media/images/icon-footer-meet-logo-e86ef0300f32be43723b879327d92f7c.svg";